import { Component, OnInit, AfterViewChecked, Injectable, ViewChild, AfterViewInit, ElementRef/*, AfterContentChecked*/ } from '@angular/core';

import { NgForm } from '@angular/forms';

import { appConfig } from '../../assets/config/app.config';

import { City } from '../city';
import { Street } from '../street';
import { ContentService } from '../content.service';

import { Step1Data } from './Step1-DataModel';

import { DateValidator } from './date.validator';

import { IMyDpOptions, IMyDateModel, IMyDate, MyDatePicker } from 'mydatepicker';

import { Step2CalcComponent } from '../step2-calc/step2-calc.component';

//import { NguiAutoCompleteDirective } from '@ngui/auto-complete';
import { NguiAutoCompleteComponent } from "@ngui/auto-complete";

import { CompleterService, CompleterData} from 'ng2-completer';

import { AutoCompleterComponent } from '../auto-completer/auto-completer.component';

import { ReCaptchaComponent } from 'angular2-recaptcha';


@Injectable()
@Component({
  selector: 'app-step1-calc',
  templateUrl: './step1-calc.component.html',
  styleUrls: ['./step1-calc.component.css'],
})
export class Step1CalcComponent implements OnInit, AfterViewInit /*, AfterViewChecked*//*, AfterContentChecked*/ {

	constructor(private thisElement: ElementRef,
		private _contentService: ContentService
		, private completerService: CompleterService) {
		let currDate = new Date(Date.now());

		let firstAgeYear = currDate.getFullYear();
		let lastAgeYear = firstAgeYear - appConfig.maxAge;

		for (let year = firstAgeYear; year >= lastAgeYear; year--)
			this.years.push(year);

		this.setDays(31);

		let that = this;
		this.monthNames.forEach(function (monthName, ix) {
			that.myDatePickerOptions.monthLabels[ix + 1] = monthName;
		});

		this.defaultBirthYear = firstAgeYear - appConfig.defaultAge;
		this.selBirthDate.year = this.defaultBirthYear;
		this.selBirthDate.month = 1;
		this.selBirthDate.day = 1;

		//this.dataService = this.completerService.local(this.citiesList, 'cityID', 'cityID');
	}

    isCaptchaMissingProperty1: boolean = true;

	errorMessage: string;

	submitted = false;
	responseReceived = false;
	isStep1Eligible?: boolean;
	isReCaptchaOk: boolean;

	form: NgForm = null;

	loadingCities: boolean;
	loadingStreets: boolean;
	loadingIsStep1Eligible: boolean;
	citiesListErr: boolean;
	streetsListErr: boolean;

	citiesList: City[];
	streetsList: Street[];

	//protected searchStr: string;
	//protected dataService: CompleterData;
	//public isOpenAutoComplete: boolean = false;

    reCaptchaKey: string = this.SiteKeyByUrl();

	citiesAutoCompleterData: CompleterData;

	step1Data: Step1Data = new Step1Data();

	isResidentOpened: boolean = false;

	highlightErrs: boolean = false;
	isShowErrs(isDataValid: boolean) {
		//debugger;
		//console.log('highlightErrs:' + highlightErrs + ' y:' + yearValid + ' m:' + monthValid + ' d:' + dayValid);
		return this.highlightErrs && !isDataValid;
	}
	highlightErrsSet(isHighlight: boolean) {
		//debugger;
		this.highlightErrs = isHighlight;
		this.isResidentOpened = false;
	}
	highlightErrsToggle() {
		//debugger;
		this.highlightErrs = !this.highlightErrs;
	}

	years: number[] = [];
	monthNames: string[] = [
		'ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'
	];
	days: number[] = [];

	today: Date = new Date();
	defaultBirthYear: number;
	selBirthDate: IMyDate = {year:0, month:0, day:0};

	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dateFormat: 'dd.mm.yyyy',
		dayLabels: { su: 'א', mo: 'ב', tu: 'ג', we: 'ד', th: 'ה', fr: 'ו', sa: 'שבת' },
		monthLabels: {},
		showTodayBtn: false,
		satHighlight: true,
		alignSelectorRight: true,
		showInputField: false,
		showClearDateBtn: false,
		//disableSince: {
		//	year: this.today.getFullYear(),
		//	month: this.today.getMonth() + 1,
		//	day: this.today.getDate()
		//},
		//disableUntil: {
		//	year: this.today.getFullYear() - appConfig.maxAge,
		//	month: 1,
		//	day: 1
		//},
		minYear: this.today.getFullYear() - appConfig.maxAge,
		maxYear: this.today.getFullYear()
		//showSelectorArrow: false,
		//selectorWidth: '260px',
		//width: '20px'
	};

	//private datePickerUsed: boolean = false;

	@ViewChild('step1Form') public step1Form: NgForm;

	@ViewChild('myDatePicker') public myDatePicker: MyDatePicker;
	//firstTimeMyDatePicker: boolean = true;

	onDateChanged(event: IMyDateModel) {
		///debugger;
		//this.setDate(event.date.year, event.date.month, event.date.day);
		this.step1Form.controls['selectedDay'].setValue(event.date.day);
		this.step1Form.controls['selectedMonth'].setValue(event.date.month);
		this.step1Form.controls['selectedYear'].setValue(event.date.year);

		this.step1Form.controls['selectedDay'].updateValueAndValidity();
		this.step1Form.controls['selectedMonth'].updateValueAndValidity();
		this.step1Form.controls['selectedYear'].updateValueAndValidity();

		this.errorMessage = null; // needed in case onSubmit has not yet activated (and therefore form.valueChanges has not yet set)
		//this.datePickerUsed = true;
		// event properties are: event.date, event.jsdate, event.formatted and event.epoc
	}

	onCalendarToggle(event: number): void {
		///debugger;
		if (event != 1 && event != 7)
			return;

		if (this.myDatePicker && event==1) {
			this.myDatePicker.selectedDate = this.selBirthDate;
			//if (this.firstTimeMyDatePicker) {
				//this.firstTimeMyDatePicker = false;
				this.myDatePicker.closeSelector(6);
				this.myDatePicker.openSelector(7);
			//}

			return;
		}

		if (event != 7)
			return;

		//let els = this.thisElement.nativeElement.getElementsByClassName('mydpicon');

		//for (let ii = 0; ii < els.length; ii++) {
		//	els[ii].style.fontFamily = 'mydatepicker';
		//}

		let els = this.thisElement.nativeElement.getElementsByClassName('icon-mydpleft');
		this.replaceClass(els, 'icon-mydpleft', 'icon-mydpleftX');

		els = this.thisElement.nativeElement.getElementsByClassName('icon-mydpright');
		this.replaceClass(els, 'icon-mydpright', 'icon-mydpleft');

		els = this.thisElement.nativeElement.getElementsByClassName('icon-mydpleftX');
		this.replaceClass(els, 'icon-mydpleftX', 'icon-mydpright');

	}

	replaceClass(els, fromClass, toClass) {
		//debugger;
		let len = els.length;
		for (let ii = 0; ii < len; ii++) {
			let el = els[0]; // By changing class each time number of elements in els is reduced by one each time
			let classN = el.className;
			classN = classN.replace(fromClass, toClass);
			el.className = classN
		};
	}

	ngOnInit() {
		///debugger;
		this.getCitiesList();

		//this.cityAutoComplete.ctrInput.nativeElement.onkeydown = (event: KeyboardEvent) => {
		//	if (event.key == 'PageDown') {
		//		debugger;
		//		//event.preventDefault();
		//		//event.stopPropagation();
		//		//event.stopImmediatePropagation();

		//		//return false;
		//	}
		//};

	}

	ngAfterViewInit() {
        ///debugger;
        setTimeout(() => this.isCaptchaMissingProperty1 = this.isCaptchaMissing(), 0);
		let els = this.thisElement.nativeElement.getElementsByClassName('icon-mydpcalendar');
		if (els.length) {
			let el0 = els[0];
			//el0.className = 'icon icon-ic-date';
			el0.className = 'icomoon icon-Calendar';
			el0.style.fontSize = '25px';
			el0.style.color = '#263c4a';
		}
	}

	//ngAfterViewChecked() {
	//ngAfterContentChecked() {
	//	debugger;
	//	if (!this.datePickerUsed)
	//		return
	//	//this.formChanged = true;
	//	//this.submitted = false;
	//	this.datePickerUsed = false;
	//	this.form.controls['selectedDay'].updateValueAndValidity();
	//	this.form.controls['selectedMonth'].updateValueAndValidity();;
	//	this.form.controls['selectedYear'].updateValueAndValidity();;
	//}

	getCitiesList() {
		///debugger;
		this.loadingCities = true;
		this.citiesListErr = false;
		this.errorMessage = null;
		this._contentService.getCitiesList()
			.subscribe(
			citiesList => {
				this.citiesList = [];
				citiesList.forEach((node, ix, nodes) => {
					this.citiesList.push(new City(
						node.cityID,
						node.cityName,
						node.districtID,
						node.districtName,
						node.municipalityID,
						node.municipalityName
					));
				});

				//this._treeViewComponent.ready()
				///debugger;
				this.loadingCities = false;

				//let dataService: CompleterData = this.completerService.local(this.citiesList, 'cityName', 'cityName');
				this.citiesAutoCompleterData = this.completerService.local(this.citiesList, 'cityName', 'cityName');
				//this.dataService = this.completerService.local(this.citiesList, 'cityName', 'cityName');
				//this.cityAutoCompleter.setDataService(dataService);
				this.cityAutoCompleter.setDataService(this.citiesAutoCompleterData);
			},
			error => { /*debugger;*/ this.errorMessage = <any>error; this.loadingCities = false; this.citiesListErr = true; }//,
			//() => { this.loadingCities = false; alert(1); }
		);

	}

	getStreets4City(city) {
		this.loadingStreets = true;
		this.streetsListErr = false;
		this.streetsList = [];
		this._contentService.getStreets4City(city)
			.subscribe(
			streetsList => {
				this.streetsList = [];
				streetsList.forEach((node, ix, nodes) => {
					this.streetsList.push(new Street(
						node.streetID,
						node.streetName
					));
				});

				//this._treeViewComponent.ready()
				this.loadingStreets = false;

				let dataService: CompleterData = this.completerService.local(this.streetsList, 'streetName', 'streetName');
				this.streetAutoCompleter.setDataService(dataService);

			},
			error => { this.errorMessage = <any>error; this.loadingStreets = false; this.streetsListErr = true;}//,
			//() => this.loadingStreets = false
			);
	}

	daysInMonth(month, year) {
		return month > 0 ? new Date(year, month, 0).getDate() : 31;
	}

	isValidDate(year, month, day) {
		///debugger;
		return Step1Data.isValidDate(year, month, day);
	}

	setDays(lastDay) {
		if (lastDay == this.days.length)
			return;
		this.days = [];
		for (let day = 1; day <= lastDay; day++)
			this.days.push(day);
	}

	setDate(year, month, day) {
		//let day = dayCtrl.value;
		//alert(year + ' ' + month + ' ' + day);
		//if (year > 0 && month > 0) {
			let lastDay = this.daysInMonth(month, year);
			this.setDays(lastDay);
		//}
		let isValid = this.step1Data.setDate(year, month, day);

		if (!isValid) {
			//dayCtrl.value = -1;
			//dayCtrl.children[0].selected = true;
			///debugger;
			//dayModel.validator(dayCtrl);
		}
		else {
			this.selBirthDate.year = year * 1; // Must convert to number - otherwise: endless loop in MyDatePicker.generateYears
			this.selBirthDate.month = month * 1;
			this.selBirthDate.day = day * 1 || this.step1Data.getDay();
		}
	}

	setSelectedCity(city) {
		this.step1Data.selectedCity = city;
		this.step1Data.selectedStreet = -1;
		this.getStreets4City(city);
	}

	tryAgainCities() {
		///debugger;
		//alert(2);
		this.loadingStreets = this.streetsListErr = false;
		this._contentService.citiesList = [];
		this.getCitiesList();
		this.step1Data.selectedCity = -1;
		this.step1Data.selectedStreet = -1;
		//alert(3);
		return false;
	}

	onSubmit(form, step2Calc?: Step2CalcComponent) {
		///debugger;
		this.errorMessage = null;
		this.submitted = true;
		this.responseReceived = false;
		if (this.form == null) {
			this.form = form;
			this.form.valueChanges
				.subscribe(data => {
					this.submitted = false, this.responseReceived = false; this.errorMessage = null;
					//if (this.step1recaptcha && this.isCaptchaValid && this.responseReceived)
					//	this.step1recaptcha.reset();
					//this.step1Data.captchaToken = this.captchaToken = null; this.isCaptchaValid = false; this.highlightErrs = false;
				});
		}

		this.loadingIsStep1Eligible = true;
		this._contentService.isStep1Eligible(this.step1Data)
			.subscribe(
			result => {
				//alert(isEligible);

				//this.isStep1Eligible = isEligible;
				this.isStep1Eligible = result.isStepEligible;

				this.isReCaptchaOk = result.isRecaptchaOk;

				this.responseReceived = true;

				//this._treeViewComponent.ready()
				this.loadingIsStep1Eligible = false;

				if (step2Calc && result.isStepEligible === null && !step2Calc.submitted && !step2Calc.responseReceived) {
					step2Calc.onSubmit(step2Calc.form);
				}
			},
			error => { this.errorMessage = <any>error; this.loadingIsStep1Eligible = false; },
			() => { /*console.log("onComplete")*/ }
			);

	}

	@ViewChild("cityAutoCompleter") private cityAutoCompleter: AutoCompleterComponent;
	@ViewChild("streetAutoCompleter") private streetAutoCompleter: AutoCompleterComponent;

	onCitySelected(selected: number) {
		///debugger;
		//let cityId: number = -1;
		//if (selected)
		//	cityId = selected.originalObject.cityID;
		//this.setSelectedCity(cityId);
		this.setSelectedCity(selected);
	}

	onStreetSelected(selected: number) {
		this.step1Data.selectedStreet = selected;
	}

	public isCaptchaValid: boolean = false;
	public captchaToken: string = null;

	@ViewChild("step1recaptcha") private step1recaptcha: ReCaptchaComponent;

	isCaptchaSet(): boolean {
		//debugger;
		let captchaRes: string = null;
		//if (typeof (grecaptcha) == 'undefined' || !grecaptcha)
		//	return false;
		//try {
		//	captchaRes = grecaptcha.getResponse();
		//}
		//catch (err) { console && console.log('isCaptchaSet: ' + err) }

		//console && console.log(captchaRes);

		captchaRes = this.captchaToken;

		this.isCaptchaValid = !!captchaRes && /*the following is for the case when step1recaptcha is re-added after step2calc ui is erased */
			!!this.step1recaptcha.getResponse();

		if (captchaRes && !this.step1recaptcha.getResponse())
			// this is because step1recaptcha is re-added after step2calc ui is erased
			this.highlightErrs = false; // We could have done it on ngOnInit of step2calc

		return this.isCaptchaValid;
	}

	isCaptchaMissing(): boolean {
		let isMissing: boolean = true;
		try {
			//isMissing = typeof (grecaptcha) == 'undefined' || !grecaptcha || !document.getElementById('g-recaptcha-response');
			isMissing = typeof (grecaptcha) == 'undefined' || !grecaptcha || // !document.querySelector('[id^=g-recaptcha-response]');
				!document.querySelector('#step1captcha [id^=g-recaptcha-response]');
		}
		catch (err) { console && console.log('isCaptchaMissing: ' + err) }

		this.isCaptchaValid = !isMissing && this.isCaptchaSet();
        if (this.isCaptchaValid)
            this.isReCaptchaOk = true;

		return isMissing;
	}

	handleCorrectCaptcha(captchaRes) {
		console && console.log(captchaRes);
		this.step1Data.captchaToken = this.captchaToken = captchaRes; 
	}

	handleCaptchaExpired() {
		this.step1Data.captchaToken = this.captchaToken = null;
    }

    SiteKeyByUrl(): string {
        var ReCaptchaSiteKey = "";
        var FireArmsUrl = window.location.host.toLowerCase();
        switch (FireArmsUrl) {

            case "gov.il":
            case "www.gov.il":
                ReCaptchaSiteKey = "6Lc82j0UAAAAAO0aPEp6DK4sdq6IMCtKni6kcTIo";
                break;

            case "test.newgov.gov.il":
                ReCaptchaSiteKey = "6LdVi1IUAAAAABGeZBNTga-jrH4jPt3IG_1oaw8Y";
                break;

            case "localhost:8086":
                ReCaptchaSiteKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
                break;

            default:
                ReCaptchaSiteKey = "";
                break;
        }

        return ReCaptchaSiteKey;
    }

	// TODO: Remove this when we're done
	get diagnostic() { return JSON.stringify(this.step1Data) + ' ' + this.step1Data.birthDateString; }

}

declare var grecaptcha: any;





// WEBPACK FOOTER //
// ./src/app/step1-calc/step1-calc.component.ts